import SidebarComponent from "./SidebarComponent";

export default SidebarComponent;
